import classnames from "classnames";
import { isNotPresent } from "neetocist";
import PropTypes from "prop-types";
import { not } from "ramda";

import Columns from "./Columns";
import Download from "./Download";
import Filter from "./Filter";

const RightBlock = ({
  downloadButtonProps,
  columnsButtonProps,
  filterProps,
  dataProps,
}) => {
  const showIcons = isNotPresent(dataProps?.totalCount)
    ? true
    : dataProps?.totalCount > 0;

  return (
    <div
      data-testid="subheader-rightblock-buttons-container"
      className={classnames(
        "flex flex-row items-center justify-end gap-2",
        "[&>:not([hidden])~:not([hidden])]:border-border [&>:not([hidden])~:not([hidden])]:border-s [&>:not([hidden])~:not([hidden])]:ps-2",
        { hidden: not(showIcons) }
      )}
    >
      {downloadButtonProps && <Download {...downloadButtonProps} />}
      {columnsButtonProps && <Columns {...columnsButtonProps} />}
      {filterProps && <Filter {...filterProps} />}
    </div>
  );
};

RightBlock.propTypes = {
  /**
   * Props that are passed to the download button.
   */
  downloadButtonProps: PropTypes.shape({
    count: PropTypes.number,
    onClick: PropTypes.func,
    tooltipProps: PropTypes.object,
  }),
  /**
   * Props that are passed to the columns button, same as the `Columns` component from neetoMolecules.
   */
  columnsButtonProps: PropTypes.shape({
    actionBlock: PropTypes.node,
    tableKey: PropTypes.string,
    checkboxProps: PropTypes.object,
    columnData: PropTypes.array,
    isSearchable: PropTypes.bool,
    noColumnMessage: PropTypes.string,
    searchProps: PropTypes.object,
    onMutationSuccess: PropTypes.func,
    allowConfigurationResetOnUpdate: PropTypes.bool,
  }),
  /**
   * Props that are passed the the filter component. These are the same props as the
   * neetoFilters `Filters` component.
   */
  filterProps: PropTypes.shape({
    size: PropTypes.oneOf(["xsmall", "small", "large"]),
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    columns: PropTypes.object,
    onChange: PropTypes.func,
    onSelectorsChange: PropTypes.func,
    buttonProps: PropTypes.object,
    paneProps: PropTypes.object,
    isSearchable: PropTypes.bool,
    className: PropTypes.string,
  }),
  /**
   * Props related to data being displayed, such as tables, lists, and more. The buttons
   * will be hidden if the value of `totalCount` in `dataProps` is `0`.
   */
  dataProps: PropTypes.shape({ totalCount: PropTypes.number }),
};

export default RightBlock;
